/* eslint 'global-require': 'off' */
require('./util/custom-extend');

if (window.zxyCustomModules) {
    // 加载定制化的app.js
    window.customRequire('app').then(() => {
        require('./enter').default.setup();
    }, () => {
        require('./enter').default.setup();
    });
} else {
    require('./enter').default.setup();
}
